export const Preloader = () => (
  <div className='preloader d-none' id='preloader'>
    <div className='preloader-inner'>
      <div className='spinner'>
        <div className='dot1'></div>
        <div className='dot2'></div>
      </div>
    </div>
  </div>
);
